import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HEADER_HEIGHT = 81;

function scrollToHash(hash, smooth = true) {
  const el = document.querySelector(hash);
  if (!el) return false;
  const top = el.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT;
  window.scrollTo({ top, behavior: smooth ? "smooth" : "auto" });
  return true;
}

export function useScrollTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    scrollToHash(hash, true);
    // Async content (Sanity data) shifts layout after initial render — re-anchor
    // scroll on body resize for a short window so the user lands at the target.
    let userScrolled = false;
    const onWheel = () => { userScrolled = true; };
    const ro = new ResizeObserver(() => {
      if (userScrolled) return;
      scrollToHash(hash, false);
    });
    ro.observe(document.body);
    window.addEventListener("wheel", onWheel, { passive: true });
    window.addEventListener("touchmove", onWheel, { passive: true });
    const stop = setTimeout(() => ro.disconnect(), 2000);
    return () => {
      ro.disconnect();
      clearTimeout(stop);
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("touchmove", onWheel);
    };
  }, [pathname, hash]);
}
